export default __webpack_public_path__ + "static/media/cropped-logo.42a447a4.png";